import { useInView } from "@/hooks/use-in-view"

const STEPS = [
	{
		number: "1",
		title: "Sign up in seconds",
		description: "Email and password. That's it.",
	},
	{
		number: "2",
		title: "Add your holdings",
		description: "Search any stock, enter shares. Or bulk-import from CSV.",
	},
	{
		number: "3",
		title: "Watch your dividends grow",
		description: "Forecasts, calendar, FIRE projections — all automatic.",
	},
]

export function HowItWorks() {
	const { ref, inView } = useInView()

	return (
		<div ref={ref} className={`transition-opacity duration-700 ease-out ${inView ? "opacity-100" : "opacity-0"}`}>
			<section className="py-20 px-4 bg-sky-50/40 dark:bg-sky-950/20">
				<div className="max-w-4xl mx-auto text-center">
					<h2 className="text-3xl sm:text-4xl font-bold text-sky-950 dark:text-sky-50">
						Up and running in minutes
					</h2>
					<div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12">
						{STEPS.map(({ number, title, description }) => (
							<div key={number} className="flex flex-col items-center">
								<div className="w-12 h-12 rounded-full bg-sky-600 dark:bg-sky-500 text-white font-extrabold text-xl flex items-center justify-center shadow-[0_4px_20px_-4px_rgba(14,165,233,0.5)]">
									{number}
								</div>
								<h3 className="mt-4 text-lg font-bold text-sky-950 dark:text-sky-50">{title}</h3>
								<p className="mt-2 text-sm text-sky-900/65 dark:text-sky-300/55 leading-relaxed max-w-xs">
									{description}
								</p>
							</div>
						))}
					</div>
				</div>
			</section>
		</div>
	)
}
